/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskPriorCurrentYearAmt } from './ExecRiskPriorCurrentYearAmt';
import {
    ExecRiskPriorCurrentYearAmtFromJSON,
    ExecRiskPriorCurrentYearAmtFromJSONTyped,
    ExecRiskPriorCurrentYearAmtToJSON,
} from './ExecRiskPriorCurrentYearAmt';

/**
 * 
 * @export
 * @interface ExecRiskAdjustedNetIncome
 */
export interface ExecRiskAdjustedNetIncome {
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    NetSTCapitalGainAdjNetIncmGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    RecoveriesPYDistributionsGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    OtherGrossIncomeGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    AdjustedGrossIncomeGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    DepreciationDepletionGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    ProductionIncomeGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    OtherExpensesGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskAdjustedNetIncome
     */
    TotalAdjustedNetIncomeGrp?: Array<ExecRiskPriorCurrentYearAmt>;
}

/**
 * Check if a given object implements the ExecRiskAdjustedNetIncome interface.
 */
export function instanceOfExecRiskAdjustedNetIncome(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskAdjustedNetIncomeFromJSON(json: any): ExecRiskAdjustedNetIncome {
    return ExecRiskAdjustedNetIncomeFromJSONTyped(json, false);
}

export function ExecRiskAdjustedNetIncomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskAdjustedNetIncome {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'NetSTCapitalGainAdjNetIncmGrp': !exists(json, 'NetSTCapitalGainAdjNetIncmGrp') ? undefined : ((json['NetSTCapitalGainAdjNetIncmGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'RecoveriesPYDistributionsGrp': !exists(json, 'RecoveriesPYDistributionsGrp') ? undefined : ((json['RecoveriesPYDistributionsGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'OtherGrossIncomeGrp': !exists(json, 'OtherGrossIncomeGrp') ? undefined : ((json['OtherGrossIncomeGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'AdjustedGrossIncomeGrp': !exists(json, 'AdjustedGrossIncomeGrp') ? undefined : ((json['AdjustedGrossIncomeGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'DepreciationDepletionGrp': !exists(json, 'DepreciationDepletionGrp') ? undefined : ((json['DepreciationDepletionGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'ProductionIncomeGrp': !exists(json, 'ProductionIncomeGrp') ? undefined : ((json['ProductionIncomeGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'OtherExpensesGrp': !exists(json, 'OtherExpensesGrp') ? undefined : ((json['OtherExpensesGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'TotalAdjustedNetIncomeGrp': !exists(json, 'TotalAdjustedNetIncomeGrp') ? undefined : ((json['TotalAdjustedNetIncomeGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
    };
}

export function ExecRiskAdjustedNetIncomeToJSON(value?: ExecRiskAdjustedNetIncome | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'NetSTCapitalGainAdjNetIncmGrp': value.NetSTCapitalGainAdjNetIncmGrp === undefined ? undefined : ((value.NetSTCapitalGainAdjNetIncmGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'RecoveriesPYDistributionsGrp': value.RecoveriesPYDistributionsGrp === undefined ? undefined : ((value.RecoveriesPYDistributionsGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'OtherGrossIncomeGrp': value.OtherGrossIncomeGrp === undefined ? undefined : ((value.OtherGrossIncomeGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'AdjustedGrossIncomeGrp': value.AdjustedGrossIncomeGrp === undefined ? undefined : ((value.AdjustedGrossIncomeGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'DepreciationDepletionGrp': value.DepreciationDepletionGrp === undefined ? undefined : ((value.DepreciationDepletionGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'ProductionIncomeGrp': value.ProductionIncomeGrp === undefined ? undefined : ((value.ProductionIncomeGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'OtherExpensesGrp': value.OtherExpensesGrp === undefined ? undefined : ((value.OtherExpensesGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'TotalAdjustedNetIncomeGrp': value.TotalAdjustedNetIncomeGrp === undefined ? undefined : ((value.TotalAdjustedNetIncomeGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
    };
}

